import React from "react";
import { NavLink } from "react-router-dom";

var bnr1 = require("./../../images/background/bg-5.png");

const specializations = [
  {
    image: require("../../images/cement1.jpg"),
    title: "Premium Cement Solutions",
    description:
      "High-quality cement products from leading brands for all your construction needs. Ensuring durability and strength.",
    category: "Cement",
    link: "/products",
    icon: "fa fa-cubes",
  },
  {
    image: require("../../images/steel.webp"),
    title: "Steel & Metal Products",
    description:
      "Superior steel and metal solutions for structural applications. Trusted brands for reliable construction.",
    category: "Steel",
    link: "/products",
    icon: "fa fa-industry",
  },
  {
    image: require("../../images/PVC.jpg"),
    title: "PVC & Plumbing Solutions",
    description:
      "Complete range of PVC pipes and plumbing accessories for residential and commercial projects.",
    category: "Plumbing",
    link: "/products",
    icon: "fa fa-wrench",
  },
];

class Specialization extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full mobile-page-padding p-t80 p-b80"
          style={{
            backgroundImage: "url(" + bnr1 + ")",
            backgroundColor: "#f8f9fa",
            backgroundBlendMode: "overlay",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          {/* Background Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 1,
            }}
          />

          <div
            className="container"
            style={{ position: "relative", zIndex: 2 }}
          >
            {/* TITLE SECTION */}
            <div className="text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  color: "#333",
                  marginBottom: "15px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                Our <span style={{ color: "#3fa4ca" }}>Specializations</span>
              </h2>
              <div
                style={{
                  width: "80px",
                  height: "4px",
                  backgroundColor: "#3fa4ca",
                  margin: "0 auto 20px",
                  borderRadius: "2px",
                }}
              />
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#666",
                  maxWidth: "600px",
                  margin: "0 auto",
                  lineHeight: "1.6",
                  paddingBottom: "30px",
                }}
              >
                Discover our comprehensive range of construction materials and
                solutions, carefully selected from industry-leading brands to
                ensure quality and reliability.
              </p>
            </div>

            {/* SPECIALIZATIONS GRID */}
            <div className="row align-items-stretch">
              {/* Specialization Cards */}
              {specializations.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4 ">
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      transition: "all 0.4s ease",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                      border: "1px solid #f0f0f0",
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 40px rgba(0,0,0,0.15)";
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0,0,0,0.1)";
                    }}
                  >
                    {/* Image Section */}
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        height: "250px",
                      }}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.4s ease",
                        }}
                        onMouseOver={e => {
                          e.target.style.transform = "scale(1.1)";
                        }}
                        onMouseOut={e => {
                          e.target.style.transform = "scale(1)";
                        }}
                      />

                      {/* Category Badge */}
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          backgroundColor: "#3fa4ca",
                          color: "white",
                          padding: "8px 15px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.category}
                      </div>

                      {/* Icon Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          backgroundColor: "rgba(255, 255, 255, 0.9)",
                          color: "#3fa4ca",
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "18px",
                        }}
                      >
                        <i className={item.icon} />
                      </div>

                      {/* Gradient Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "50%",
                          background:
                            "linear-gradient(transparent, rgba(0,0,0,0.3))",
                        }}
                      />
                    </div>

                    {/* Content Section */}
                    <div
                      style={{
                        padding: "25px",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "1.4rem",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "15px",
                          lineHeight: "1.3",
                        }}
                      >
                        {item.title}
                      </h4>

                      <p
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                          marginBottom: "20px",
                          flex: 1,
                        }}
                      >
                        {item.description}
                      </p>

                      {/* Action Button */}
                      <NavLink
                        to={item.link}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "12px 25px",
                          backgroundColor: "transparent",
                          border: "2px solid #3fa4ca",
                          color: "#3fa4ca",
                          textDecoration: "none",
                          borderRadius: "25px",
                          fontSize: "14px",
                          fontWeight: "600",
                          transition: "all 0.3s ease",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                        onMouseOver={e => {
                          e.target.style.backgroundColor = "#3fa4ca";
                          e.target.style.color = "white";
                          e.target.style.transform = "translateY(-2px)";
                        }}
                        onMouseOut={e => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#3fa4ca";
                          e.target.style.transform = "translateY(0)";
                        }}
                      >
                        Explore Products
                        <i
                          className="fa fa-arrow-right"
                          style={{ marginLeft: "8px", fontSize: "12px" }}
                        />
                      </NavLink>
                    </div>
                  </div>
                </div>
              ))}

              {/* Info/CTA Section */}
              {/* <div className="col-lg-12 col-md-12">
                <div style={{
                  backgroundColor: "white",
                  borderRadius: "15px",
                  padding: "40px",
                  textAlign: "center",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  border: "1px solid #f0f0f0",
                  marginTop: "20px",
                  background: "linear-gradient(135deg, #FF6B35 0%, #FF8A50 100%)",
                  color: "white"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <i className="fa fa-tools" style={{ fontSize: "48px", marginBottom: "15px", opacity: 0.9 }} />
                  </div>
                  <h3 style={{
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginBottom: "15px",
                    color: "white"
                  }}>
                    Building Excellence Together
                  </h3>
                  <p style={{
                    fontSize: "1.1rem",
                    marginBottom: "25px",
                    opacity: 0.95,
                    maxWidth: "600px",
                    margin: "0 auto 25px",
                    lineHeight: "1.6"
                  }}>
                    When it comes to your construction needs, don't compromise on quality. 
                    Trust our expertise and premium products to make your vision a reality.
                  </p>
                  <div style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
                    <NavLink
                      to="/all-products"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "15px 30px",
                        backgroundColor: "white",
                        color: "#FF6B35",
                        textDecoration: "none",
                        borderRadius: "25px",
                        fontSize: "16px",
                        fontWeight: "600",
                        transition: "all 0.3s ease",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.transform = "translateY(-3px)";
                        e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.2)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      View All Products
                    </NavLink>
                    <NavLink
                      to="/contact"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "15px 30px",
                        backgroundColor: "transparent",
                        border: "2px solid white",
                        color: "white",
                        textDecoration: "none",
                        borderRadius: "25px",
                        fontSize: "16px",
                        fontWeight: "600",
                        transition: "all 0.3s ease",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "white";
                        e.target.style.color = "#FF6B35";
                        e.target.style.transform = "translateY(-3px)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "white";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      Get Quote
                    </NavLink>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Specialization;
